export const NAME = 'homePanels';
export const ID = 'home-panels';
